module.exports = __webpack_public_path__ + "img/User.61b05148.png";